export function genRect (inArr, yKeys, { minX, minY, maxX, maxY, padding }, { max, min }, { multiOffset, minBarHeight, stacked, barPaddingRate, yGrid }) {
    let arr = []
    if (!stacked) {
        inArr.forEach(item => { arr = arr.concat(yKeys.map(key => item[key])) })
    } else {
        inArr.forEach(item => {
            let sum = 0
            yKeys.forEach(key => {
                sum += item[key]
            })
            arr.push(sum)
        })
    }
    const span = max - min
    const yMagic = Math.floor(Math.log(span) / Math.log(10))
    const unit = Math.pow(10, yMagic)
    let gridMin = Math.floor(min / unit) * unit
    let gridMax = Math.ceil(max / unit) * unit
    let step = (gridMax - gridMin) / (yGrid - 1)

    if (unit === 1 && step > 1 && Math.ceil(step) !== step) {
        step = Math.ceil(step)
        gridMax = gridMin + step * (yGrid - 1)
    }
    if (gridMin < 0 && gridMax > 0) {
        gridMin = Math.floor(min / step) * step
        gridMax = Math.ceil(max / step) * step
    }
    const gridX = (maxX - minX - padding) / (inArr.length)
    const rate = (maxY - minY) / (gridMax - gridMin)
    const barPadding = gridX * barPaddingRate
    return inArr.map((item, i) => {
        const points = []
        let prevHeight = 0
        yKeys.forEach((key, j) => {
            const index = i
            const value = item[key] || 0
            const title = value
            const barHeight = Math.abs(value) * rate
            let x = (index * gridX + minX) + barPadding
            let width = (gridX - (barPadding * 2)) / (stacked ? 1 : yKeys.length)
            let y = 0
            let height = 0
            if (stacked) {
                height = barHeight
                if (j === 0) {
                    prevHeight = height
                } else {
                    y = prevHeight
                    prevHeight += height
                }
            } else {
                height = barHeight > minBarHeight ? barHeight : minBarHeight
                if (multiOffset && j > 0) {
                    x += j * gridX / yKeys.length - (j * barPadding / (yKeys.length / 2))
                }
            }
            const offsetX = width * 0.05
            if (multiOffset) {
                x += offsetX
                width *= 0.9
            }
            points.push({
                index,
                key,
                value,
                x,
                y,
                width,
                height,
                title
            })
        })

        return points
    })
}
